import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ProviderNoteModel } from 'src/app/models/shopping/provider-note.model';
import { ProviderNoteService } from 'src/app/services/shopping/provider-note.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-prefix-note-number',
  templateUrl: './prefix-note-number.component.html',
  styleUrls: ['./prefix-note-number.component.scss'],
  standalone: false
})
export class PrefixNoteNumberComponent implements OnInit {

  public readonly config = inject(DynamicDialogConfig);
  private readonly formBuilder = inject(FormBuilder);
  private readonly providerNoteService = inject(ProviderNoteService);
  private readonly ref = inject(DynamicDialogRef);
  private readonly toastHandlerService = inject(ToastHandlerService);

  disabledActions: boolean = false;
  formProviderNote: FormGroup = new FormGroup({});
  permissionUpdatable: boolean = false;
  providerNoteModel: ProviderNoteModel = new ProviderNoteModel();
  suscription: Subscription;
  updateProviderNote: boolean = false;

  async ngOnInit(): Promise<void> {
    this.validateForm(new ProviderNoteModel());

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.providerNoteModel = inputs.providerNoteModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledActions = inputs.disabledForm;
    });

    this.validateForm(this.providerNoteModel);

    if (this.disabledActions) {
      this.formProviderNote.disable();
    } else {
      this.formProviderNote.enable();
    }
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  close() {
    const data: ModalObjectType = {};
    data.params = { updateProviderNote: this.updateProviderNote };
    this.ref.close(data);
  }

  async send() {
    Object.keys(this.formProviderNote.controls).forEach((key) => {
      const control = this.formProviderNote.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formProviderNote.valid) {
      let prefix = this.formProviderNote.get("prefix")?.value;
      const noteNumber = this.formProviderNote.get("noteNumber")?.value;
      if (prefix.trim() === '') prefix = null;

      this.providerNoteModel.prefix = prefix;
      this.providerNoteModel.noteNumber = noteNumber;
      try {
        await firstValueFrom(this.providerNoteService.updateProviderNote(this.providerNoteModel));
        this.updateProviderNote = true;
        this.toastHandlerService.showToast('success', `La nota proveedor se modificó exitosamente.`);
      } catch (error) {
        console.error('Error al guardar la nota proveedor.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      prefix: {
        required: 'Debe ingresar el prefijo',
        maxlength: 'El prefijo no puede tener más de 6 caracteres'
      },
      invoiceNumber: {
        required: 'Debe ingresar el número de factura',
        min: 'Debe ingresar un número de factura mayor a 0'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formProviderNote.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(providerNoteModel: ProviderNoteModel) {
    this.formProviderNote = this.formBuilder.group({
      prefix: [providerNoteModel.prefix, [Validators.maxLength(6)]],
      noteNumber: [providerNoteModel.noteNumber, [Validators.required, Validators.min(1)]]
    });
  }

}
